<div class="modal opened">
      <div class="modal-feedback-main {{type}}">
        <em class="modal-icon"></em>
        <h2>{{message}}</h2>
        <p class="txt" [innerHTML]="text">dasdasdasdad</p>
        <fieldset [ngClass]="{'two-buttons': secondButtonText != ''}">
          <core-helpers-forms-button
            [type]="'grey'"
            [text]="secondButtonText"
            (submit)="onSecondAction()"
            [hidden]="secondButtonText == ''"
          ></core-helpers-forms-button>
          <core-helpers-forms-button-white 
            [disabled]="disabled"
            [text]="buttonText" 
            (submit)="onAction()"
          ></core-helpers-forms-button-white>
        </fieldset>
    </div>
</div>
